import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge } from './ot'
import StatsCard from './stats-card'
const BaseCardView1_5 = ({
    stats = [
        {
            value: 1250,
            label: "瀏覽次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
        },
        {
            value: 45,
            label: "撰寫文案",
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
        },
        {
            value: 320,
            label: "點擊次數",
            backgroundColor: "bg-blue-50",
            animationDuration: 2000,
            animationDelay: 0,
        },
        {
            value: 28,
            label: "複製次數",
            backgroundColor: "bg-green-50",
            animationDuration: 1500,
            animationDelay: 200,
        },
    ],
    ...props
}, ref) => {


    return (
        <>
            <StatsCard
                stats={stats}
                layout="horizontal"
                contentAlign="left"
                columnsPerRow={2}
                connection="connected"
                size="xs"
                enableAnimation={false}
                backgroundColor="bg-white-50"
                responsiveColumns={{
                    xs: 2, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2
                }}
                bolder={false}
                {...props}
            />
        </>
    )
}

export default BaseCardView1_5
